import React from 'react';
import { useSearch } from '../contexts/SearchContext';
import { formatInvestmentAddress, formatTenantHQAddress } from '../utils/addressFormatter';
import './Footer.css';

function Footer({ selectedProperty = null }) {
  const { investmentData, globalConfig, isMultiInvestment, loading } = useSearch();

  if (loading || !investmentData) {
    return null;
  }

  // Prospekt z stage (tylko na karcie), pozostałe z investment (zawsze)
  const prospectusUrl = selectedProperty?.stage?.prospectus_url;
  const privacyPolicyUrl = investmentData?.privacy_policy_url;
  const contactUrl = investmentData?.contact_url;

  const hasAnyLinks = prospectusUrl || privacyPolicyUrl || contactUrl;

  // W trybie multi-investment tenant jest resolvowany z wybranego lokalu
  // W trybie single-investment tenant pochodzi z głównej inwestycji
  const tenant = isMultiInvestment
    ? selectedProperty?.tenant
    : investmentData.tenant;

  // W trybie multi-investment nie pokazuj tenanta na liście (tylko na karcie lokalu)
  const showTenantSection = isMultiInvestment ? !!selectedProperty : true;

  return (
    <footer className="property-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Adres inwestycji:</h4>
          <p>{formatInvestmentAddress(investmentData)}</p>
        </div>
        {showTenantSection && tenant && (
          <div className="footer-section footer-section--tenant">
            <h4>Dane inwestora:</h4>
            <p>{tenant.investor_name}</p>
            <p>{formatTenantHQAddress(tenant)}</p>
            <p>NIP: {tenant.investor_nip}</p>
            <p>KRS: {tenant.investor_krs}</p>
          </div>
        )}
      </div>

      {/* Wyświetlaj linki jeśli są dostępne */}
      {hasAnyLinks && (
        <div className="footer-links">
          {/* Prospekt tylko na karcie lokalu */}
          {selectedProperty && prospectusUrl && selectedProperty.propertyType !== 'lokal uslugowy' && (
            <a href={prospectusUrl} target="_blank" rel="noopener noreferrer" className="footer-link">
              Prospekt informacyjny
            </a>
          )}
          {/* Privacy i Contact zawsze, jeśli są ustawione */}
          {privacyPolicyUrl && (
            <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer" className="footer-link">
              Polityka prywatności
            </a>
          )}
          {contactUrl && (
            <a
              href={contactUrl}
              target={contactUrl.startsWith('http') ? '_blank' : undefined}
              rel={contactUrl.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="footer-link"
            >
              Skontaktuj się z nami
            </a>
          )}
        </div>
      )}

      <div className="footer-credits">
        <p>
          Made with <span className="heart-icon">♥</span> by{' '}
          {globalConfig?.twopoint_url ? (
            <a
              href={globalConfig.twopoint_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'underline', cursor: 'pointer' }}
            >
              TwoPoint
            </a>
          ) : (
            'TwoPoint'
          )}
        </p>
      </div>
    </footer>
  );
}

export default Footer;